const HeaderTransparency = (($) => {

    // client height
    const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

    // Header element identifier
    const HEADER_NAME = '.header';

    const BLACK = '0';

    let headerTransparency;

    let last_known_scroll_position = 0;
    let ticking = false;

    /**
     *
     */
    class HeaderTransparency {

        /**
         * Constructor
         * @param element
         */
        constructor(element) {

            // register element
            this._element = element;

            // detect background color as RGB
            this.rgb = element.css('background-color').match(/\d+/g).shift();
        }

        /**
         * calculate background opacity of header (50% => 0, 75% => 1)
         */
        setBackgroundColor(last_known_scroll_position) {
            let scrollTop = last_known_scroll_position || $(window).scrollTop();
            let opacity = this.getOpacity(scrollTop);

            this._element.css({
                'background-color': 'rgba(' + this.rgb + ',' + this.rgb + ',' + this.rgb + ',' + opacity + ')',
                'box-shadow': '0 20px 40px -20px rgba(' + BLACK + ',' + BLACK + ',' + BLACK + ',' + opacity / 10 + ')'
            });
        }

        /**
         * get Opacity
         *
         * @param scrollTop
         * @return {number}
         */
        getOpacity (scrollTop = 0) {
            return ((this.hasPictureTeaserOnFirstPosition() ? Math.max(Math.min(((scrollTop / vh) - .5) *4, 1), 0) : 1));
        }

        // check existence of fullscreen / xl teaser as first element on page
        // Selector .picture-teaser-container-fullscreen:fist-child, .picture-teaser-container-xl:fist-child
        hasPictureTeaserOnFirstPosition(){
            return ($('.sr-only + .picture-teaser-container-fullscreen, .picture-teaser-container-fullscreen:first-child, .picture-teaser-container-xl:first-child, .carousel--fullscreen:first-child').length > 0)
        }
    }

    $(window).ready(function (event) {

        let header = $(HEADER_NAME);

        if (header.length) {

            if (header.hasClass('header--fade')) {

                headerTransparency = new HeaderTransparency(header);

                // init
                headerTransparency.setBackgroundColor();

                window.addEventListener('scroll', function(e) {
                    last_known_scroll_position = window.scrollY;

                    if (!ticking) {
                        window.requestAnimationFrame(function() {
                            headerTransparency.setBackgroundColor(last_known_scroll_position)
                            ticking = false;
                        });

                        ticking = true;
                    }
                });
            }
        }
    });

})(jQuery);

// export default HeaderTransparency
